import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Colors } from '~/config/Colors';

const FinanceChart = ({ previsto = {}, real = {} }) => {
  const chartData = [
    {
      name: 'Custo',
      previsto: previsto.custo || 0,
      real: real.custo || 0,
    },
    {
      name: 'Lucro',
      previsto: previsto.lucro || 0,
      real: real.lucro || 0,
    },
    {
      name: 'Horas',
      previsto: previsto.horas || 0,
      real: real.horas || 0,
    },
  ];

  const formatCurrency = value => {
    return `R$ ${value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatHours = value => {
    const absValue = Math.abs(value);
    const hours = Math.floor(absValue);
    const minutes = Math.round((absValue - hours) * 60);
    return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length > 0) {
      const dataPoint = payload[0].payload;
      const isHoras = dataPoint.name === 'Horas';
      const isLucro = dataPoint.name === 'Lucro';
      const previstoVal = dataPoint.previsto || 0;
      const realVal = dataPoint.real || 0;

      const diferenca = isLucro ? realVal - previstoVal : previstoVal - realVal;
      const percentual = previstoVal !== 0 ? ((diferenca / previstoVal) * 100).toFixed(1) : 0;

      const diferencaColor = diferenca >= 0 ? Colors.ft_color_8 : Colors.ft_color_10;

      return (
        <div
          style={{
            backgroundColor: Colors.bgCardColor,
            padding: '12px 16px',
            border: `1px solid ${Colors.Border_Color_1}`,
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          }}
        >
          <p
            style={{
              color: Colors.text_Color_1,
              marginBottom: '8px',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            {dataPoint.name}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <p
              style={{
                color: Colors.Color9,
                margin: 0,
                fontSize: '13px',
                fontWeight: '500',
              }}
            >
              Previsto: {isHoras ? formatHours(previstoVal) : formatCurrency(previstoVal)}
            </p>
            <p style={{ color: Colors.Color9, margin: 0, fontSize: '13px', fontWeight: '500' }}>
              Real: {isHoras ? formatHours(realVal) : formatCurrency(realVal)}
            </p>
            <div
              style={{
                marginTop: '6px',
                paddingTop: '6px',
                borderTop: `1px solid ${Colors.Border_Color_1}`,
              }}
            >
              <p
                style={{
                  color: diferencaColor,
                  margin: 0,
                  fontWeight: 'bold',
                  fontSize: '13px',
                }}
              >
                Diferença: {diferenca >= 0 ? '+' : ''}
                {isHoras ? formatHours(diferenca) : formatCurrency(diferenca)}
              </p>
              <p
                style={{
                  color: diferencaColor,
                  margin: 0,
                  fontSize: '12px',
                  fontWeight: 'normal',
                }}
              >
                ({diferenca >= 0 ? '+' : ''}
                {percentual}%)
              </p>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart
        data={chartData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke={Colors.Border_Color_1} />
        <XAxis dataKey="name" stroke={Colors.text_Color_1} fontSize="1rem" />
        <YAxis stroke={Colors.text_Color_1} fontSize="1rem" />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255, 255, 255, 0.1)' }} />
        <Legend
          wrapperStyle={{
            color: Colors.text_Color_1,
          }}
        />
        <Bar
          dataKey="previsto"
          fill={Colors.Color4}
          name="Previsto"
          radius={[8, 8, 0, 0]}
          maxBarSize={60}
        />
        <Bar
          dataKey="real"
          fill={Colors.text_Color_1}
          stroke={Colors.Border_Color_1}
          name="Real"
          radius={[8, 8, 0, 0]}
          maxBarSize={60}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default FinanceChart;
